(() => {
  const init = () => {
    document.querySelectorAll('[data-menu-toggle]').forEach(button => {
      if (button.dataset.bound) return;
      button.dataset.bound = 'true';
      const menu = document.getElementById(button.getAttribute('aria-controls'));
      if (!menu) return;
      const close = () => { button.setAttribute('aria-expanded', 'false'); button.setAttribute('aria-label', 'Open navigation'); menu.hidden = true; };
      button.addEventListener('click', () => {
        const expanded = button.getAttribute('aria-expanded') !== 'true';
        button.setAttribute('aria-expanded', String(expanded));
        button.setAttribute('aria-label', expanded ? 'Close navigation' : 'Open navigation');
        menu.hidden = !expanded;
      });
      menu.addEventListener('keydown', event => { if (event.key === 'Escape') { close(); button.focus(); } });
      menu.querySelectorAll('a').forEach(link => link.addEventListener('click', close));
    });
    const interest = new URLSearchParams(window.location.search).get('interest');
    const interestInput = document.querySelector('[data-quote-interest]');
    if (interest && interestInput && !interestInput.value) interestInput.value = interest.slice(0, 200);
    document.querySelectorAll('[data-variant-select]').forEach(select => {
      if (select.dataset.bound) return;
      select.dataset.bound = 'true';
      select.addEventListener('change', () => {
        const option = select.selectedOptions[0];
        if (!option) return;
        const section = select.closest('.shopify-section') || select.closest('section');
        if (!section) return;
        const price = section.querySelector('[data-product-price]');
        if (price && option.dataset.price) price.textContent = option.dataset.price;
        const compare = section.querySelector('[data-product-compare-price]');
        if (compare) { compare.textContent = option.dataset.comparePrice || ''; compare.hidden = !option.dataset.comparePrice; }
        const available = option.dataset.available === 'true';
        const button = section.querySelector('[data-add-to-cart]');
        if (button) { button.disabled = !available; button.textContent = available ? 'Add to cart' : 'Unavailable'; }
        const stock = section.querySelector('[data-product-availability]');
        if (stock) stock.textContent = available ? 'Available to order' : 'Unavailable';
        const shipping = section.querySelector('[data-product-shipping]');
        if (shipping) shipping.textContent = option.dataset.requiresShipping === 'true' ? 'Delivery options confirmed at checkout.' : 'This is a service. No physical shipping applies.';
        const quantity = section.querySelector('[data-product-quantity]');
        if (quantity) {
          quantity.min = option.dataset.min || '1'; quantity.step = option.dataset.step || '1';
          if (option.dataset.max) quantity.max = option.dataset.max; else quantity.removeAttribute('max');
          quantity.value = quantity.min;
        }
        const url = new URL(window.location.href); url.searchParams.set('variant', option.value);
        window.history.replaceState({}, '', url);
      });
    });
    document.querySelectorAll('[data-product-form],form.cm-product-form').forEach(form => {
      if (form.dataset.bound) return;
      form.dataset.bound = 'true';
      form.addEventListener('submit', () => {
        const button = form.querySelector('[data-add-to-cart]');
        if (button && !button.disabled) { button.setAttribute('aria-busy', 'true'); button.textContent = 'Adding…'; }
      });
    });
  };
  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
